import {
  Col,
  Collapse,
  Form,
  Row,
  Input,
  Tooltip,
  Checkbox,
  Select,
  Tag,
  Button,
  InputNumber,
} from "antd";
import { toJS } from "mobx";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { dataSuperior, toUpdateElementInJson } from "../utils/Utils";
import { ShowHide } from "./ShowHide";

const { Panel } = Collapse;
const { Option } = Select;
const { useImperativeHandle, forwardRef } = React;
export const PracticeProfile = forwardRef(
  ({ step, tool, data, all, input, toUpdateData, setStep, dso }, ref) => {
    const [formPractice] = Form.useForm();
    const callback = (key) => {};

    const tagRender = (props) => {
      const { label, value, closable, onClose } = props;

      return (
        <Tag
          color={"#EEEEEE"}
          closable={closable}
          onClose={onClose}
          style={{
            marginRight: 3,
            fontFamily: "Gotham",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "20px",
            lineHeight: "20px",

            color: "#000000",
          }}
        >
          {label}
        </Tag>
      );
    };

    useEffect(() => {
      var json = {};

      data[0].value.forEach((element) => {
        if (element.fieldName == "products") {
          element.value.forEach((sub) => {
            json[sub.fieldName] = getValue(sub.fieldName);
          });
        } else {
          json[element.fieldName] = getValue(element.fieldName);
        }
      });
      json.speciality = json.speciality != "" ? json.speciality : [];
      formPractice.setFieldsValue(json);
    }, [data]);

    const toDisplay = (name) => {
      var display = false;
      data[0].value.forEach((element) => {
        if (element.fieldName == name) {
          display = element.display;
        }
      });
      return display;
    };

    const getValue = (name) => {
      var res = "";
      data[0].value.forEach((element) => {
        if (element.fieldName == "products") {
          element.value.forEach((sub) => {
            if (sub.fieldName == name) {
              res = sub.value;
            }
          });
        }
        if (element.fieldName == name) {
          res = element.value;
        }
      });

      return res;
    };

    const onChange = () => {
      var p = formPractice.getFieldsValue();
      for (var key of Object.keys(p)) {
        data[0].value = toUpdateElementInJson(data[0].value, key, p[key]);
      }

      toUpdateData(data);
    };
    const toHideUnhide = (id, value) => {
      data[0].value.forEach((element) => {
        if (element.fieldName == id) {
          element.display = value;
        }
      });
      toUpdateData(data);
    };
    const toUpdateRadio = (id, value) => {
      data[0].value.forEach((element) => {
        if (element.fieldName == id) {
          element.value = value == 1 ? false : true;
        }
      });
      toUpdateData(data);
    };
    useImperativeHandle(ref, () => ({
      validate() {
        // to validate this component
        formPractice
          .validateFields()
          .then((res) => {
            setStep(step + 1);
          })
          .catch((errorInfo) => {
            return false;
          });
      },
    }));
    const practiceProfile = (
      <div>
        <Form form={formPractice} name="pricing" onChange={() => onChange()}>
          <Row style={{ marginTop: "2vh" }}>
            <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
              <Tooltip
                color="#EBEBEA"
                fontFamily="Gotham"
                fontSize="20px"
                style={{ textColor: "#6a6e80", textAlign: "right" }}
                placement="rightTop"
                title={
                  <FormattedMessage
                    id={dso ? "nameDSOTooltip" : "nameClinicTooltip"}
                  />
                }
              >
                <img src="/images/icons/bull.svg" />
              </Tooltip>

              <span
                className="roi--label-section"
                style={{ marginLeft: "2vh" }}
              >
                {dso ? (
                  <FormattedMessage id="dsoName" />
                ) : (
                  <FormattedMessage id="clinicName" />
                )}{" "}
              </span>
            </Col>
            <Col xl={0} lg={0} md={1}></Col>

            <Col xl={4} lg={6} md={10}>
              <Form.Item name="clinicName">
                <Input />
              </Form.Item>
            </Col>

            <Col xl={3} lg={1} md={0}></Col>

            <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
              <Tooltip
                color="#EBEBEA"
                fontFamily="Gotham"
                fontSize="20px"
                style={{ textColor: "#6a6e80", textAlign: "right" }}
                placement="rightTop"
              >
                <img src="/images/icons/bull-empty.svg" />
              </Tooltip>

              <span
                className="roi--label-section"
                style={{ marginLeft: "2vh" }}
              >
                <FormattedMessage id="openDays" />
              </span>
            </Col>
            <Col xl={0} lg={0} md={1}></Col>

            <Col xl={5} lg={7} md={10}>
              <Form.Item
                name="openDays"
                defaultValue={5}
                rules={[
                  {
                    validator: dataSuperior,
                  },
                ]}
              >
                <Input type="number" suffix="days/week" />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginTop: "2vh" }}>
            <>
              <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                <Tooltip
                  color="#EBEBEA"
                  fontFamily="Gotham"
                  fontSize="20px"
                  style={{ textColor: "#6a6e80" }}
                  placement="rightTop"
                  title={
                    <FormattedMessage
                      id={
                        dso ? "specialitiesDSOTooltip" : "specialitiesTooltip"
                      }
                    />
                  }
                >
                  <img src="/images/icons/bull.svg" />
                </Tooltip>

                <span
                  className="roi--label-section"
                  style={{ marginLeft: "2vh" }}
                >
                  <FormattedMessage id="speciality" />
                </span>
              </Col>
              <Col xl={0} lg={0} md={1}></Col>

              <Col xl={4} lg={6} md={10}>
                <Form.Item
                  name="speciality"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    showArrow
                    onChange={(e) => onChange(e)}
                    tagRender={tagRender}
                    style={{ width: "100%" }}
                  >
                    <Option value="Orthodontics">
                      <FormattedMessage id="Orthodontics" />
                    </Option>
                    <Option value="Implantologist">
                      <FormattedMessage id="Implantologist" />
                    </Option>
                    <Option value="Endodontist">
                      <FormattedMessage id="Endodontist" />
                    </Option>
                    <Option value="Periodontist">
                      <FormattedMessage id="Periodontist" />
                    </Option>
                    <Option value="OralSurgeon">
                      <FormattedMessage id="OralSurgeon" />
                    </Option>
                    <Option value="Hygienist">
                      <FormattedMessage id="Hygienist" />
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={3} lg={1} md={0}></Col>

              <Col xl={5} lg={5} md={10}>
                {dso && (
                  <>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80", textAlign: "right" }}
                      placement="rightTop"
                    >
                      <img src="/images/icons/bull-empty.svg" />
                    </Tooltip>
                    <span
                      className="roi--label-section"
                      style={{ marginLeft: "2vh" }}
                    >
                      <FormattedMessage id="numberClinics" />
                    </span>
                  </>
                )}
              </Col>
              <Col xl={0} lg={0} md={1}></Col>
              <Col xl={5} lg={7} md={10}>
                {dso && (
                  <Form.Item
                    name="numberClinics"
                    defaultValue={5}
                    rules={[
                      {
                        validator: dataSuperior,
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                )}
              </Col>
            </>
          </Row>
          <Row gutter={24} style={{ marginTop: "2vh" }}>
            <Col span={23} style={{ display: "flex" }}>
              <Tooltip
                placement="leftBottom"
                title={<FormattedMessage id="whichDentalMind" />}
              >
                <img src="/images/icons/bull.svg" />
              </Tooltip>

              <span
                className="roi--label-section"
                style={{ marginTop: "1vh", marginLeft: "2vh" }}
              >
                <FormattedMessage id="roiFor" />
              </span>
            </Col>
          </Row>

          <Row gutter={24} style={{ marginTop: "2vh" }}>
            <Col span={8}>
              <Form.Item name="SmileMateFor" valuePropName="checked">
                <Checkbox>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormattedMessage id="SmileMateFor" />
                  </span>
                </Checkbox>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item name="monitoringFor" valuePropName="checked">
                <Checkbox>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormattedMessage id="monitoringFor" />
                  </span>
                </Checkbox>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="bracesFor" valuePropName="checked">
                <Checkbox>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormattedMessage id="bracesFor" />
                  </span>
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ marginTop: "1vh" }}>
            <Col xl={12} lg={12} md={24}>
              <ShowHide
                activeElement={toDisplay("separateRole")}
                radio={true}
                all={true}
                toUpdateRadio={toUpdateRadio}
                toHideUnhide={toHideUnhide}
                showInput={input}
                idOfTooltip={"separateRoleTooltip"}
                checked={getValue("separateRole")}
                id="separateRole"
              />
            </Col>

            <Col xl={12} lg={12} md={24}>
              <ShowHide
                all={true}
                toUpdateRadio={toUpdateRadio}
                toHideUnhide={toHideUnhide}
                checked={getValue("separateTeensAdults")}
                radio={true}
                showInput={input}
                activeElement={toDisplay("separateTeensAdults")}
                idOfTooltip={"separateTeensTooltip"}
                id="separateTeensAdults"
              />
            </Col>
          </Row>

          <Row style={{ marginTop: "2vh" }}>
            <Col xl={12} lg={12} md={24}>
              <ShowHide
                toUpdateRadio={toUpdateRadio}
                toHideUnhide={toHideUnhide}
                checked={getValue("showHourly")}
                radio={true}
                all={true}
                showInput={input}
                idOfTooltip="showHourlyTooltip"
                id="showHourly"
                activeElement={toDisplay("showHourly")}
                disabled={true}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );

    const practiceProfileTool = (
      <div>
        <Form form={formPractice} name="pricing" onFinish={onChange}>
          {step > 0 && (
            <>
              <Row style={{ marginTop: "2vh" }}>
                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80", textAlign: "right" }}
                    placement="rightTop"
                    title={<FormattedMessage id="nameClinicTooltip" />}
                  >
                    <img src="/images/icons/bull.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="clinicName" />
                  </span>
                </Col>
                <Col xl={4} lg={6} md={10}>
                  <Form.Item
                    name="clinicName"
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xl={2} lg={1} md={0}></Col>

                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                    title={<FormattedMessage id="specialitiesTooltip" />}
                  >
                    <img src="/images/icons/bull.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="speciality" />
                  </span>
                </Col>
                <Col xl={4} lg={7} md={10}>
                  <Form.Item
                    name="speciality"
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showArrow
                      onChange={(e) => onChange(e)}
                      tagRender={tagRender}
                      style={{ width: "100%" }}
                    >
                      <Option value="Orthodontics">
                        <FormattedMessage id="Orthodontics" />
                      </Option>
                      <Option value="Implantologist">
                        <FormattedMessage id="Implantologist" />
                      </Option>
                      <Option value="Endodontist">
                        <FormattedMessage id="Endodontist" />
                      </Option>
                      <Option value="Periodontist">
                        <FormattedMessage id="Periodontist" />
                      </Option>
                      <Option value="OralSurgeon">
                        <FormattedMessage id="OralSurgeon" />
                      </Option>
                      <Option value="Hygienist">
                        <FormattedMessage id="Hygienist" />
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: "2vh" }}>
                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                  >
                    <img src="/images/icons/bull-empty.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="Adress" />
                  </span>
                </Col>
                <Col xl={4} lg={6} md={10}>
                  <Form.Item
                    name="adress"
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xl={2} lg={1}></Col>
                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                  >
                    <img src="/images/icons/bull-empty.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="openDays" />
                  </span>
                </Col>
                <Col xl={4} lg={7} md={10}>
                  <Form.Item
                    name="openDays"
                    defaultValue={5}
                    rules={[
                      {
                        validator: dataSuperior,
                      },
                    ]}
                  >
                    <Input type="number" suffix="days/week" />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ marginTop: "2vh" }}>
                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                  >
                    <img src="/images/icons/bull-empty.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="doctorName" />
                  </span>
                </Col>
                <Col xl={4} lg={6} md={10}>
                  <Form.Item
                    name="doctorName"
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xl={2} lg={1} md={0}></Col>
                <Col xl={5} lg={5} md={10} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                  >
                    <img src="/images/icons/bull-empty.svg" />
                  </Tooltip>

                  <span
                    className="roi--label-section"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="email" />
                  </span>
                </Col>
                <Col xl={4} lg={7} md={10}>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Invalid email",
                        type: "email",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {step > 1 && (
            <>
              {" "}
              <Row gutter={24} style={{ marginTop: "2vh" }}>
                <Col span={23} style={{ display: "flex" }}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                    title={<FormattedMessage id="whichDentalMind" />}
                  >
                    <img src="/images/icons/bull.svg" />
                  </Tooltip>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "1vh", marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="roiFor" />
                  </span>
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: "2vh", marginLeft: "2vh" }}>
                <Col span={8}>
                  <Form.Item name="SmileMateFor" valuePropName="checked">
                    <Checkbox>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="SmileMateFor" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="monitoringFor" valuePropName="checked">
                    <Checkbox>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="monitoringFor" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="bracesFor" valuePropName="checked">
                    <Checkbox>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="bracesFor" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: "1vh" }}>
                {toDisplay("separateRole") && (
                  <Col xl={11} lg={11} md={24}>
                    <ShowHide
                      toUpdateRadio={toUpdateRadio}
                      idOfTooltip={"separateRoleTooltip"}
                      activeElement={toDisplay("separateRole")}
                      radio={true}
                      all={true}
                      checked={formPractice.getFieldValue("separateRole")}
                      toHideUnhide={toHideUnhide}
                      showInput={input}
                      id="separateRole"
                    />
                  </Col>
                )}
                {toDisplay("separateTeensAdults") && (
                  <Col xl={11} lg={11} md={24}>
                    <ShowHide
                      toUpdateRadio={toUpdateRadio}
                      all={true}
                      toHideUnhide={toHideUnhide}
                      checked={formPractice.getFieldValue(
                        "separateTeensAdults"
                      )}
                      radio={true}
                      showInput={input}
                      activeElement={toDisplay("separateTeensAdults")}
                      idOfTooltip={"separateTeensTooltip"}
                      id="separateTeensAdults"
                    />
                  </Col>
                )}

                {toDisplay("showHourly") && (
                  <Col xl={11} lg={11} md={24}>
                    <ShowHide
                      all={true}
                      toHideUnhide={toHideUnhide}
                      toUpdateRadio={toUpdateRadio}
                      checked={formPractice.getFieldValue("showHourly")}
                      radio={true}
                      showInput={input}
                      idOfTooltip="showHourlyTooltip"
                      id="showHourly"
                      activeElement={toDisplay("showHourly")}
                      disabled={true}
                    />
                  </Col>
                )}
              </Row>
            </>
          )}
          {step < 3 && (
            <Form.Item>
              <div style={{ textAlign: "center" }}>
                <Button
                  className="roi--button-primary"
                  htmlType="submit"
                  style={{
                    marginTop: "4vh",
                    textAlign: "center",
                    marginBottom: "2vh",
                  }}
                >
                  <FormattedMessage id="next" />
                </Button>
              </div>
            </Form.Item>
          )}
        </Form>
      </div>
    );
    return (
      <Collapse
        defaultActiveKey={["1"]}
        onChange={callback}
        expandIconPosition="right"
      >
        <Panel
          className="roi--collapse-header-green"
          header={
            dso ? (
              <FormattedMessage id="dsoProfile" />
            ) : (
              <FormattedMessage id="practiceProfile" />
            )
          }
          key="1"
        >
          <>{tool ? practiceProfileTool : practiceProfile}</>
        </Panel>
      </Collapse>
    );
  }
);
